import React, { useState } from "react";
import { Technic, Workshop } from "../types";
import { technicService } from "../services/dataService";
import AlertModal from "./AlertModal";
import "./TechnicModal.css";

interface CreateTechnicModalProps {
  isOpen: boolean;
  onClose: () => void;
  onTechnicCreated: (technic: Technic) => void;
  workshops: Workshop[];
}

const CreateTechnicModal: React.FC<CreateTechnicModalProps> = ({
  isOpen,
  onClose,
  onTechnicCreated,
  workshops,
}) => {
  const [newTechnic, setNewTechnic] = useState({
    name: "",
    description: "",
    category: "",
    workshopId: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Alert Modal state
  const [alertModal, setAlertModal] = useState<{
    isOpen: boolean;
    message: string;
    type: "info" | "success" | "warning" | "error";
  }>({ isOpen: false, message: "", type: "info" });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const createdTechnic = await technicService.create(newTechnic);
      setNewTechnic({
        name: "",
        description: "",
        category: "",
        workshopId: "",
      });
      onTechnicCreated(createdTechnic);
      onClose();
    } catch (error) {
      console.error("Teknik oluşturulurken hata:", error);
      setAlertModal({
        isOpen: true,
        message: "Teknik oluşturulurken bir hata oluştu!",
        type: "error",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    if (!isSubmitting) {
      setNewTechnic({
        name: "",
        description: "",
        category: "",
        workshopId: "",
      });
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="technic-modal-overlay">
      <div className="technic-modal" style={{ maxWidth: "37.5rem" }}>
        <div className="technic-modal-header">
          <h2>Yeni Teknik Oluştur</h2>
          <button
            className="technic-modal-close"
            onClick={handleClose}
            disabled={isSubmitting}
          >
            ×
          </button>
        </div>

        <div className="technic-modal-body">
          <form className="technic-create-form" onSubmit={handleSubmit}>
            <div className="technic-form-grid">
              <div className="technic-form-group">
                <label>Teknik Adı *</label>
                <input
                  type="text"
                  value={newTechnic.name}
                  onChange={(e) =>
                    setNewTechnic({ ...newTechnic, name: e.target.value })
                  }
                  placeholder="Örn: Dijital Baskı"
                  required
                  disabled={isSubmitting}
                />
              </div>
              <div className="technic-form-group">
                <label>Kategori</label>
                <input
                  type="text"
                  value={newTechnic.category}
                  onChange={(e) =>
                    setNewTechnic({ ...newTechnic, category: e.target.value })
                  }
                  placeholder="Örn: Baskı Teknikleri"
                  disabled={isSubmitting}
                />
              </div>
              <div className="technic-form-group">
                <label>Atölye</label>
                <select
                  value={newTechnic.workshopId}
                  onChange={(e) =>
                    setNewTechnic({
                      ...newTechnic,
                      workshopId: e.target.value,
                    })
                  }
                  disabled={isSubmitting}
                >
                  <option value="">-- Atölye Seçiniz --</option>
                  {workshops.map((ws) => (
                    <option key={ws.workshopId} value={ws.workshopId}>
                      {ws.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="technic-form-group full-width">
                <label>Açıklama</label>
                <textarea
                  value={newTechnic.description}
                  onChange={(e) =>
                    setNewTechnic({
                      ...newTechnic,
                      description: e.target.value,
                    })
                  }
                  placeholder="Teknik hakkında kısa bir açıklama..."
                  rows={4}
                  disabled={isSubmitting}
                />
              </div>
            </div>
            <div className="technic-form-actions">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClose}
                disabled={isSubmitting}
              >
                İptal
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Oluşturuluyor..." : "Oluştur"}
              </button>
            </div>
          </form>
        </div>

        {/* Alert Modal */}
        <AlertModal
          isOpen={alertModal.isOpen}
          message={alertModal.message}
          type={alertModal.type}
          onClose={() => setAlertModal({ ...alertModal, isOpen: false })}
        />
      </div>
    </div>
  );
};

export default CreateTechnicModal;
